import { render } from "./AccessType.vue?vue&type=template&id=8f533014"
import script from "./AccessType.vue?vue&type=script&lang=js"
export * from "./AccessType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__